import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { PageType } from 'enums';
import { createFetchPageAction, scorePage } from 'common/page/actions';
import { fetchScheduleModule, scoreScheduleModule } from 'common/scheduleModule/actions';
import { isIntlSelector, showOneIdLoginSelector } from 'common/selectors/appSelector';
import BannerAd from 'common/ads/BannerAd';
import OverlayAd from 'common/ads/OverlayAd';
import BucketListContainer from 'common/page/buckets/BucketListContainer';
import MainContainer from 'common/page/common/MainContainer';
import TopLayoutContainer from 'common/page/common/TopLayoutContainer';
import { oneIdLoggedInSelector } from 'common/selectors/oneIdSelector';

// create landing page(e.g. home, espnplus, product)
export default function createLandingPage(options = {}) {
    const { pageName = 'home' } = options;

    const LandingPage = ({ isIntl, showOneIdLogin, isLoggedIn }) => {
        const showLogin = !isLoggedIn && showOneIdLogin;
        // NOTE: Display Overlay Ads on `home`, `espnplus` pages generated by createLandingPage
        const bannerAd = isIntl ? [<BannerAd key="banner_ad" />] : [<OverlayAd key="overlay_ad" />];
        return (
            <MainContainer className="watch-home" pre={bannerAd} showLogin={showLogin}>
                <TopLayoutContainer />
                <div className="layout-full layout-full--watch">
                    <section className="col-a">
                        <BucketListContainer pageType={PageType.HOME} />
                    </section>
                </div>
            </MainContainer>
        );
    };

    LandingPage.loadActions = [
        (params, query, lang) => createFetchPageAction(pageName, params, query, lang),
        (params, query, lang) => fetchScheduleModule(lang)
    ];

    LandingPage.refreshInterval = 65; // 1 min and 5 seconds

    LandingPage.onRefresh = ({ dispatch, routeParams, lang, location: { query = {} } }) => {
        dispatch(createFetchPageAction(pageName, routeParams, query, lang))
            .then(() => {
                dispatch(scorePage());
            });
        dispatch(fetchScheduleModule(lang))
            .then(() => {
                dispatch(scoreScheduleModule());
            });
    };

    LandingPage.propTypes = {
        isIntl: PropTypes.bool,
        showOneIdLogin: PropTypes.bool,
        isLoggedIn: PropTypes.bool
    };

    const mapStateToProps = (state) => ({
        isIntl: isIntlSelector(state),
        showOneIdLogin: showOneIdLoginSelector(state),
        isLoggedIn: oneIdLoggedInSelector(state)
    });

    return connect(mapStateToProps)(LandingPage);
}



// WEBPACK FOOTER //
// ./app/common/createLandingPage.js